import { render } from "./ConfirmModal.vue?vue&type=template&id=5ee6e4cb&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import "./ConfirmModal.vue?vue&type=style&index=0&id=5ee6e4cb&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee6e4cb"]])

export default __exports__